import { render, staticRenderFns } from "./academic_ppt_management.vue?vue&type=template&id=54e2c38f&scoped=true&"
import script from "./academic_ppt_management.vue?vue&type=script&lang=js&"
export * from "./academic_ppt_management.vue?vue&type=script&lang=js&"
import style0 from "./academic_ppt_management.vue?vue&type=style&index=0&id=54e2c38f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e2c38f",
  null
  
)

export default component.exports